import type {PartialComponentExport} from '../constants'
import type {WmlFile} from '@wix/document-services-types'

export const parseJsonFile = ({content}: WmlFile<'json'>): PartialComponentExport['other'] => JSON.parse(content)
